import { hasQueryStringParameter } from "owa-querystring";
import type { PltBlocker } from "owa-performance-types";

// Keyed by PltBlocker so renaming or adding a blocker fails to compile until this map is updated
const pltBlockerToPasMetric: Record<PltBlocker, string> = {
    ribbon: "Ribbon Rendered (ribbon)",
    suiteux: "Suite Header Rendered (suiteux)",
};

const bootTimingToPasMetric: Record<string, string> = {
    sd: "Startup Data (sd)",
    offsd: "Offline Startup Data (offsd)",
    rbsp: "Run Before Start Promise (rbsp)",
    msal: "MSAL Auth (msal)",
    mjs: "Bootstrap Javascript Load (mjs)",
    sp: "Session Promises (sp)",
    ren: "Render (ren)",
    postren: "PLT Blocker Wait (postren)",
    plt: "Page Load Time (plt)",
    tti: "Time-to-Interactive (tti)",
    smi1: "Select Mail Item 1 (smi1)",
    smi2: "Select Mail Item 2 (smi2)",
    lagEvents: "Lag events at 0m (lagEvents)",
    lagEventsDurationSum: "Lag duration sum at 0m (lagEventsDurationSum)",
    lagEventsDurationSumSquared: "Lag squared-duration sum at 0m (lagEventsDurationSumSquared)",
    loaf: "Long Animation Frames at 0m (loaf)",
    loafDurationSum: "LoAF duration sum at 0m (loafDurationSum)",
    loafDurationSumSquared: "LoAF squared-duration sum at 0m (loafDurationSumSquared)",
    mi: "Mail Index (mi)",
    in: "Index (in)",
    MailAppLoadSucceeded: "Mail App Load Succeeded",
    CalendarAppLoadSucceeded: "Calendar App Load Succeeded",
    CalendarModuleContentRendered: "Calendar Module Content Rendered",
    // Places Related Timings
    PlacesTenantSettingsLoaded: "Places Tenant Settings Loaded",
    PlacesAppLoadSucceeded: "Places App Load Succeeded",
    // Loading screen and PLT blockers
    ls_e: "Loading Screen Removed (ls_e)",
    ...pltBlockerToPasMetric,
};

const isPerformanceSupported = self?.performance;

export function pasMetricsEnabled(): boolean {
    return hasQueryStringParameter("pas");
}

/**
 * Add a metric to the window.__pageTimings for the PAS tool to read.
 * More information on the PAS tool can be found at aka.ms/PAS
 * @param name Name of the metric
 */
export function addPASKeyMetric(name: string, customDuration?: number): void {
    if ((!customDuration && !isPerformanceSupported) || !pasMetricsEnabled()) {
        // If we don't have the duration and performance is not supported, we can't add the metric
        // We also skip the metric if we don't have the pas metrics enabled
        return;
    }
    
    const metricName = bootTimingToPasMetric[name];
    // If it's not a known metric name don't add as a page timing
    if (!metricName) {
        return;
    }
    const duration = customDuration ?? performance.now();
    const timings = self._pageTimings ?? (self._pageTimings = {});
    
    if (timings[metricName] === undefined) {
        // Round the duration to limit storage bloat on the PAS service
        timings[metricName] = Math.round(duration);
    }
}
